/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useAuth } from "context/AuthProvider";

import { useNavigate } from "react-router-dom";
var ps;

const Sidebar = (props) => {
  const {empresa, logOut} = useAuth();
  
  const handleLogout = (e) =>{
    e.preventDefault()
    logOut();
  }
  const navigate = useNavigate();
  const handleDatosEmpresa = (e) => {
    e.preventDefault();
    navigate("/admin/empresa")
  }
  
  const handleDescripciones =(e) =>{
    e.preventDefault();
    navigate("/admin/motivosAusencia")
  }

    const handleEnvioInformes =(e) =>{
    e.preventDefault();
    navigate("/admin/envioInformes")
  }

  const handleAsistente =(e) =>{
    e.preventDefault();
    navigate("/admin/asistente")
  }
   const handleChangePassword = (e) => {
    e.preventDefault();
  
   navigate("/admin/configuracion");

  }

  const [collapseOpen, setCollapseOpen] = useState();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if(prop.layout === "/admin"){
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
            >
              <i className={prop.icon} />
              {prop.name}
            </NavLink>
          </NavItem>
        );
      }
      
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          
            <img
              alt={logo.imgAlt}
              className=" "
              src={logo.imgSrc}
              style={{maxWidth: 200}}
            
              
            /> 
        
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
         
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                    src={require("../../assets/img/brand/favicon.png")}
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
            <DropdownItem  onClick={(e) => handleDatosEmpresa(e)}>
                  <i className="ni ni-badge" />
                  <span>Datos empresa</span>
                </DropdownItem>
                <DropdownItem  onClick={(e) => handleChangePassword(e)}>
                  <i className="ni ni-lock-circle-open" />
                  <span>Contraseña</span>
                </DropdownItem> 
              <DropdownItem  onClick={(e) => handleDescripciones(e)}>
                  <i className="ni ni-collection"/>
                  <span>Motivos ausencia</span>
                </DropdownItem>
   
            <DropdownItem  onClick={(e) => handleAsistente(e)}>
              <i className="ni ni-hat-3" />
              <span>Asistente</span>
            </DropdownItem>
            <DropdownItem  onClick={(e) => handleEnvioInformes(e)}>
              <i className="ni ni-email-83" />
              <span>Envio informes</span>
            </DropdownItem>
            <DropdownItem  onClick={(e) => handleLogout(e)}>
              <i className="ni ni-user-run" />
              <span>Cerrar sesión</span>
            </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc}  />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}
          
          {/* Navigation */}
          <Nav navbar>{createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className="my-3" />
        
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;

